import AnalyticsEngineBase from "./../analyticsenginebase";

/**
 * @typedef {"preprod"|"prod"} Environment
 */

export default class AnalyticsEngineTealium extends AnalyticsEngineBase {
  trackEventName = "body_bottom";

  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);

    const {
      tealium: { utagUrl, utagSyncUrl, cpmtUrl },
    } = options;

    this.injectTealiumScripts({
      utagUrl,
      utagSyncUrl,
      cpmtUrl,
    });
  }

  getPageViewPayload(data) {
    const pageNumber = this.getEditionPageNumber(data);
    const { editionToken, bundleDate } =
      this.getEditionTokenAndMagazineDate(data);
    return { editionToken, bundleDate, pageNumber };
  }

  getAlbViewPayload(data) {
    const articleTitle = this.getAlbArticleTitle(data);
    const { editionToken, bundleDate } =
      this.getEditionTokenAndMagazineDate(data);
    return { bundleDate, articleTitle, editionToken };
  }

  getEditionPageNumber(data) {
    return data.eventData.bundle.publication.pages[0].pagePosition;
  }

  getEditionTokenAndMagazineDate(data) {
    const editionToken = data.eventData.bundle.downloadToken;
    const bundleDate = this.formatDate(data.eventData.bundle.bundleDateTime);
    return { editionToken, bundleDate };
  }

  getAlbArticleTitle(data) {
    return data.eventData.bundle.publication.pages[0].articles[0].title;
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
    return `${year}${month}${day}`;
  }

  getIsReady() {
    return typeof window.utag.track === "function";
  }

  /**
   * @param {string} domain
   * @param {string} path
   * @param {Environment} env
   */
  injectUtagConfig({ domain, path, env }) {
    const script = document.createElement("script");
    script.text = `window.utag_cfg_ovrd = { domain: '${domain}', path: '${path}', env: '${env}' };`;
    document.head.appendChild(script);
  }

  /**
   * @param {string} utagUrl
   * @param {string} utagSyncUrl
   * @param {string} cpmtUrl
   */
  injectTealiumScripts({ utagUrl, utagSyncUrl, cpmtUrl }) {
    if (!utagUrl || !utagSyncUrl || !cpmtUrl) {
      // eslint-disable-next-line no-console
      console.error(
        "Could not inject the Tealium scripts because one or more of the required URLs are undefined.",
        {
          utagUrl,
          utagSyncUrl,
          cpmtUrl,
        }
      );
      return;
    }

    const utagScript = document.createElement("script");
    utagScript.src = utagUrl;
    utagScript.crossOrigin = "anonymous";

    const utagDataVariable = document.createElement("script");
    utagDataVariable.type = "text/javascript";
    utagDataVariable.text = `var utag_data = {};`;

    const utagSyncScript = document.createElement("script");
    utagSyncScript.src = utagSyncUrl;
    utagSyncScript.crossOrigin = "anonymous";

    const cpmtScript = document.createElement("script");
    cpmtScript.src = cpmtUrl;
    document.body.prepend(cpmtScript);

    document.head.appendChild(utagSyncScript);
    document.body.prepend(utagScript);
    document.body.prepend(utagDataVariable);
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/engines/analyticsEngineTealiumBase.js